﻿

$(document).ready(function () {
    var redestinationLoggingPage = new RedestinationLoggingPage();
    redestinationLoggingPage.init();
    $(".log-filter-dropdown").on("change select", function () {
        //Check whether option with value  exists
        var option = $("option[value='" + this.value + "']", this);
        if (option && option.length > 0) {
                 option
                .attr("selected", true).siblings()
                .removeAttr("selected");
        }
        var currentlySelectedFilterDate = this.value;
        if ($.trim(currentlySelectedFilterDate) != "") {
            RedestinationLoggingFunction.enableButtons();
        } else {
            RedestinationLoggingFunction.disableButtons();
        }
    });
    // enhance table saw to make responsive table
    $(document).trigger("enhance.tablesaw");
});

var RedestinationLoggingFunction = RedestinationLoggingFunction || (function () {
    var blockUI = function () {
        $("#loader").show();
    };
    var unBlockUI = function () {
        $("#loader").hide();
    };
    var disableButtons = function () {
        $("#fetchActionLogs").addClass("disabled-btn");
    };
    var enableButtons = function () {
        $("#fetchActionLogs").removeClass("disabled-btn");
    };

    return {
        blockUI: blockUI,
        unBlockUI: unBlockUI,
        enableButtons: enableButtons,
        disableButtons: disableButtons
    };
})();

var RedestinationLoggingPage = function () {

    var hideActionLogs = function () {
        $('.js-hide-show-action-logs').hide();
    };

    var showActionLogs = function () {
        $('.js-hide-show-action-logs').show();
    };

    var getCurrentlySelectedFilterDate = function () {
        return $("#SelectedFilterDate").val();
    };

    var requests = [];

    var fetchActionLogs = function () {

        hideActionLogs();
        RedestinationLoggingFunction.blockUI();

        $.each(requests, function (index, request) {
            request.abort();
        });

        requests = [];

        var actionLogsDefered = $.ajax({
            type: "Get",
            url: "/api/massomstyrning/action-logs",
            async: true,
            cache: false,
            data: { selectedFilterDate: getCurrentlySelectedFilterDate()},
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function (data) {
                if (data) {
                    if (data.actionLogs && data.actionLogs.length !== 0) {
                        $('.actionLogsPlaceHolder').html(data.actionLogs);
                        /* little fade in effect */
                        $('.actionLogsPlaceHolder').fadeIn('fast');
                    }
                }
            },
            error: function (jqXHR, status, exception) {
                console.error("Something went wrong with the AJAX request for fetching action logs!" + "</br>" + exception.Message);
                $('.actionLogsPlaceHolder').html("<h2>Failed to fetch action logs</h2>");
            }
        });

        requests.push(actionLogsDefered);

        $.when.apply($, requests).then(function () {
            RedestinationLoggingFunction.unBlockUI();
            showActionLogs();
        });
    };
    var fetchActionLogsClickEvent = function () {
        $("#fetchActionLogs").click(function () { fetchActionLogs(); });
    };
    var init = function () {
        fetchActionLogsClickEvent();
    };
    return {
        init: init
    };
};
